'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _TreeSelect = require('./TreeSelect');

var _TreeSelect2 = _interopRequireDefault(_TreeSelect);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

exports["default"] = _TreeSelect2["default"];
module.exports = exports['default'];